import React, { useState, useEffect } from 'react';
import {Body1} from '../../../ui-library';

const Timer = ({startDate}) => {

    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    /***
     * getTime - get the current time
     * @param startDate - the start date that the timer will start counting from
     */
    const getTime = (startDate: number) => {

        const currentTime = Date.now();

        const timeDifference = Math.floor((currentTime - startDate) / 1000);

        setDays(Math.floor(timeDifference / (60 * 60 * 24)));
        setHours(Math.floor((timeDifference % (60 * 60 * 24)) / (60 * 60)));
        setMinutes(Math.floor((timeDifference % (60 * 60)) / 60));
        setSeconds(timeDifference % 60);

    };

    useEffect(() => {
        const interval = setInterval(() => getTime(startDate), 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Body1> {`${days}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`} </Body1>
    );
};

export default Timer;
